export function Footer() {
	return (
		<footer className="border-t border-pastel-border bg-white">
			<div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
				<div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
					<div className="flex items-center gap-2 text-sm font-bold text-pastel-black">
						<span>&#10024;</span>
						<span>0G Vibe</span>
					</div>

					<div className="flex items-center gap-6">
						<a
							href="https://docs.0g.ai"
							target="_blank"
							rel="noopener noreferrer"
							className="text-sm text-pastel-gray hover:text-pastel-black transition-colors"
						>
							Docs
						</a>
						<a
							href="https://discord.gg/0glabs"
							target="_blank"
							rel="noopener noreferrer"
							className="text-sm text-pastel-gray hover:text-pastel-black transition-colors"
						>
							Discord
						</a>
						<a
							href="https://twitter.com/0aboratory"
							target="_blank"
							rel="noopener noreferrer"
							className="text-sm text-pastel-gray hover:text-pastel-black transition-colors"
						>
							Twitter
						</a>
						<a
							href="https://github.com/0glabs"
							target="_blank"
							rel="noopener noreferrer"
							className="text-sm text-pastel-gray hover:text-pastel-black transition-colors"
						>
							GitHub
						</a>
					</div>

					<p className="text-xs text-pastel-gray">
						Powered by <span className="font-medium">0G Chain</span>
					</p>
				</div>
			</div>
		</footer>
	);
}
